import { ICurrency } from '@helpers/types/quotes';
import * as yup from 'yup';

export const shipmentDetailsValidationSchema = yup.object().shape({
  warehouseDetails: yup.mixed().nullable().required('Please select a warehouse'),

  deliveryLocation: yup.object().shape({
    companyName: yup.string().nullable(),
    address: yup.string().nullable(),
    email: yup.object().required('Email is required')
  }),

  identifiers: yup.object().shape({
    invoiceNumber: yup.string(),
    quoteNumber: yup.string()
  }),

  additionalNotes: yup.string()
});

const amountWithCurrencyValidation = (currencyField: string) =>
  yup
    .number()
    .nullable()
    .typeError('Amount must be a number')
    .test('currency-required', 'Currency is required when amount is entered', function (value) {
      if (!value) return true; // If no amount, validation passes
      const parent = this.parent;
      return !!parent[currencyField]; // Check if currency is selected
    });

export const instructionAndChargesValidationSchema = yup.object().shape({
  carrierInfo: yup.object().shape({
    name: yup.string().required('Carrier name is required'),
    quoteId: yup.string()
  }),

  instructions: yup.object().shape({
    emergencyContact: yup.string(),
    originInstructions: yup.string(),
    destinationInstructions: yup.string(),
    originAccessorials: yup.string(),
    destinationAccessorials: yup.string(),
    special: yup.string()
  }),

  freightCharges: yup
    .object()
    .shape({
      prepaid: amountWithCurrencyValidation('prepaidCurrency'),
      prepaidCurrency: yup.mixed<ICurrency>().nullable(),

      collect: amountWithCurrencyValidation('collectCurrency'),
      collectCurrency: yup.mixed<ICurrency>().nullable(),

      thirdParty: amountWithCurrencyValidation('thirdPartyCurrency'),
      thirdPartyCurrency: yup.mixed<ICurrency>().nullable()
    })
    .test(
      'at-least-one',
      'At least one freight charge is required',
      (value) => !!(value.prepaid || value.collect || value.thirdParty)
    )
});
